module.exports = __webpack_public_path__ + "img/img95.165769ee.png";